import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { TenantBankAccount } from './TenantBankAccount.entity';

export class CostCenter<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: deaktiviert */
  disabled?: boolean;
  /** Alias: ersteNummer */
  firstNumber?: number;
  /** Alias: insertTime */
  insertTime?: string;
  /** Alias: letzteNummer */
  lastNumber?: number;
  /** Alias: mandantennummer */
  tenantNumber?: number;
  /** Alias: name */
  name?: string;
  /** Alias: nummer */
  number?: number;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: zusatz */
  additive?: string;
  /** Alias: bankverbindungCode */
  bankDetailsId?: number;
  /** Alias: bankverbindung */
  bankDetails?: TenantBankAccount<T>;
  /** Alias: ustIdNr */
  ustIdNr?: string;
  /** Alias: firmenname */
  firmName?: string;
  /** Alias: strasse */
  street?: string;
  /** Alias: pLZ */
  postalCode?: string;
  /** Alias: ort */
  city?: string;
  /** Alias: land */
  country?: string;
  /** Alias: bundesland */
  state?: string;
  /** Alias: telefon */
  phoneNumber?: string;
  /** Alias: telefax */
  faxNumber?: string;
  /** Alias: internet */
  internet?: string;
  /** Alias: beraternummer */
  advisorNumber?: number;
  /** Alias: steuernummer */
  taxNumber?: string;
  /** Alias: mandantHandelsregisterGerichtsstand */
  tenantCommercialRegisterJuristication?: string;
  /** Alias: mandantHandelsregisterNummer */
  tenantCommercialRegisterNumber?: string;
  /** Alias: mandantGeschaeftsfuehrer */
  tenatnCEO?: string;
  /** Alias: mandantEMail */
  tenantEMail?: string;

  __typename?: string;
}

const fields: FieldDefinitions<CostCenter> = {
  id: {
    alias: 'code',
  },
  disabled: {
    alias: 'deaktiviert',
  },
  firstNumber: {
    alias: 'ersteNummer',
  },
  insertTime: {
    alias: 'insertTime',
  },
  lastNumber: {
    alias: 'letzteNummer',
  },
  tenantNumber: {
    alias: 'mandantennummer',
  },
  name: {
    alias: 'name',
  },
  number: {
    alias: 'nummer',
  },
  updateTime: {
    alias: 'updateTime',
  },
  additive: {
    alias: 'zusatz',
  },
  bankDetailsId: {
    alias: 'bankverbindungCode',
  },
  bankDetails: {
    alias: 'bankverbindung',
    entity: Entities.tenantBankAccount,
  },
  ustIdNr: {
    alias: 'ustIdNr',
  },
  firmName: {
    alias: 'firmenname',
  },
  street: {
    alias: 'strasse',
  },
  postalCode: {
    alias: 'pLZ',
  },
  city: {
    alias: 'ort',
  },
  country: {
    alias: 'land',
  },
  state: {
    alias: 'bundesland',
  },
  phoneNumber: {
    alias: 'telefon',
  },
  faxNumber: {
    alias: 'telefax',
  },
  internet: {
    alias: 'internet',
  },
  advisorNumber: {
    alias: 'beraternummer',
  },
  taxNumber: {
    alias: 'steuernummer',
  },
  tenantCommercialRegisterJuristication: {
    alias: 'mandantHandelsregisterGerichtsstand',
  },
  tenantCommercialRegisterNumber: {
    alias: 'mandantHandelsregisterNummer',
  },
  tenatnCEO: {
    alias: 'mandantGeschaeftsfuehrer',
  },
  tenantEMail: {
    alias: 'mandantEMail',
  },
  __typename: {
    alias: '__typename',
  },
};

export const costCenterEntityDefinition: EntitiyDefinition<CostCenter> = {
  local: {},
  remote: {
    /**
     * Use getCostCenter instead of getKostenstellen
     */
    queryName: 'getCostCenter',
    fragmentName: 'Kostenstelle',
    withPaginationWrapper: true,
    mutations: {
      upsert: {
        mutationName: 'upsertCostCenter',
        args: [
          { name: 'input', type: 'InputKostenstelle!' },
          { name: 'drySave', type: 'Boolean' },
        ],
      },
    },
    params: [
      { name: 'querySize', type: 'Int' },
      { name: 'queryPage', type: 'Int' },
      { name: 'querySortOrder', type: 'SortOrderStyle' },
      { name: 'querySortBy', type: 'String' },
      { name: 'querySortByEx', type: '[SortByPair]' },
      { name: 'filter', type: 'String' },
    ],
  },
  fieldDefinitions: fields,
};
